module.exports = __webpack_public_path__ + "static/image4-baf111eda45a48c5101bb33097f7ac1c.jpg";